import * as yup from "yup";

export const addProductSchema = yup.object().shape({
  name: yup.string().required("Product name is required"),

  description: yup.string().optional(),

  category_id: yup.string().required("Category is required"),

  base_price: yup
    .number()
    .required("Price is required")
    .positive("Price must be positive")
    .typeError("Price must be a number"),

  stock_quantity: yup
    .number()
    .transform((value) => (isNaN(value) || value === "" ? 0 : value))
    .default(0)
    .min(0, "Stock cannot be negative")
    .typeError("Stock must be a number"),

  min_order_quantity: yup
    .number()
    .transform((value) => (isNaN(value) || value === "" ? 0 : value))
    .default(0)
    .min(0, "Min order cannot be negative")
    .typeError("Min order must be a number"),

  files: yup
    .mixed()
    .required("Product image is required")
    .test(
      "fileExists",
      "At least one file is required",
      (value) => value?.length > 0
    ),
});

export const editProductSchema = yup.object().shape({
  name: yup
    .string()
    .required("Product name is required")
    .min(3, "Product name must be at least 3 characters")
    .max(100, "Product name must be less than 100 characters"),

  description: yup.string().required("Description is required"),

  category_id: yup.string().required("Category is required"),

  base_price: yup
    .number()
    .required("Price is required")
    .positive("Price must be positive")
    .typeError("Price must be a number"),

  stock_quantity: yup
    .number()
    .required("Stock quantity is required")
    .min(0, "Stock cannot be negative")
    .typeError("Stock must be a number"),

  min_order_quantity: yup
    .number()
    .required("Min order quantity is required")
    .positive("Min order must be positive")
    .typeError("Min order must be a number"),
});
